// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeenAd":"co_a bhy_fm bhy_vv bhy_xg bhy_h"};